export const TestID = {
  WohnpreisMap: 'wohnpreis-map',
  Legend: 'map-legend',
  POILegend: 'map-poi-legend',
};
